<template>
    <div class="card-container">
        <common-top-form :model="formModel" buttonName="保存" @openAddDialog="addInfo()" :submitService="submitService" :show="false"
                         :submitData="commonParams" @success="onSuccess" addShowPower="/updateMemRateLevelChnFee">
            <select-organs v-model="formModel.tatSimpleId" :selectValue="formModel.tatSimpleId"></select-organs>
                <el-form-item label="会员等级" v-if="formModel.tatSimpleId">
                    <el-select v-model="formModel.levelId" placeholder="请选择">
                        <el-option
                            v-for="item in levelNameList"
                            :key="item.id"
                            :label="item.levelName"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
        </common-top-form>
        <!--<div class="item-box" v-for="(item,index) in itemList" :key="index">-->
            <!--<level-list ref="levelList" :model="item" :needEdit="hasPerm('/updateMemRateLevelChnFee')" :show="index < oldLength" @saveSuccess="getList"-->
                        <!--:levelNameList="itemLevelNameList" @submit="submitlast"></level-list>-->
        <!--</div>-->
        <el-collapse v-model="activeNames">
            <el-collapse-item :title="`等级名称：${item.levelName}`" v-for="(item,index) in itemList" :key="index" :name="item.id">
                <level-list ref="levelList" :model="item" :needEdit="false" :show="index < oldLength" @saveSuccess="getList"
                            :levelNameList="itemLevelNameList" @submit="submitlast"></level-list>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>
    import CommonTopForm from 'components/common/CommonTopForm'
    import LevelList from 'components/common/LevelList'
    import SelectOrgans from 'components/business/SelectOrgans'

    import MemberLevelService from 'service/MemberLevelService'
    import MemberLevelRateService from 'service/MemberLevelRateService'
    import {loadMixin, dialogMixin} from "mixin";
    import {mapGetters} from 'vuex'

    export default {
        name: "memberchannelrank",
        data() {
            return {
                formModel: {
                    levelId: '',
                    tatSimpleId: '',
                },
                options: [{
                    value: '',
                    label: '',
                }],
                itemList: [],
                levelNameList: [],
                all: [{
                    id: '',
                    levelName: '全部'
                }],
                oldLength: 0,
                submitService: MemberLevelRateService.list,
                itemLevelNameList: [],
                enableList:[],
                activeNames:[],
                flag:[],
            }
        },
        inject: ['reload'],
        mixins: [loadMixin, dialogMixin],
        components: {
            CommonTopForm,
            SelectOrgans,
            LevelList
        },
        computed: {
            commonParams() {
                const params = {
                    tatSimpleId: this.formModel.tatSimpleId,
                    levelId: this.formModel.levelId,
                };
                return params;
            },
            ...mapGetters(['userId'])
        },
        watch:{
            'formModel.tatSimpleId'(val, oldVal){
                this.formModel.levelId = '';
                this.getLevelList();
                this.getList();
            },
        },
        methods: {
            getLevelList() {
                this.doLoad(MemberLevelService.select, this.commonParams, res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        this.itemLevelNameList = result.memLevelManageList;
                        this.levelNameList = [...this.all, ...this.itemLevelNameList];

                    });
                }, '信息获取失败')
            },
            getList() {
                this.doLoad(this.submitService, this.commonParams, res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        this.itemList = result;
                        this.oldLength = this.itemList.length;
                        this.activeNames = [];
                        this.itemList.forEach(item=>{
                            this.activeNames.push(item.id)
                        })
                    });
                }, '信息获取失败')
            },
            onSuccess(res) {
                this.doCheck(res, res => {
                    const result = res.contents;
                    this.itemList = result;
                    this.oldLength = this.itemList.length;
                });
            },
            addInfo() {
                this.enableList = [];
                this.flag = [];
                this.itemList.forEach((item,index) => {
                    this.$refs.levelList[index].submit();
                })
            },
            submitlast(val){
                this.flag.push(val);
                val ? this.enableList.push(val) : this.enableList = [];

                if (this.flag.length == this.itemList.length && this.enableList.length != this.itemList.length){
                    this.showError('会员费率低于机构成本费率，请重新配置。')
                }

                if (this.enableList.length == this.itemList.length){
                    this.doSave();
                }


            },
            doSave() {
                let qpayAmts = '';
                let qpayRates = '';
                let memFeeIds = '';
                this.itemList.forEach(item => {
                    item.lineList.forEach(val => {
                        qpayAmts = qpayAmts + ',' + val.qpayAmt * 100;
                        qpayRates = qpayRates + ',' + val.qpayRate;
                        memFeeIds = memFeeIds + ',' + val.memFeeId;
                    })
                });

                const params = {
                    qpayAmts: qpayAmts.slice(1),
                    qpayRates: qpayRates.slice(1),
                    memFeeIds: memFeeIds.slice(1)
                };

                this.doLoad(MemberLevelService.updateMemRateLevelChnFee, params, res => {
                    this.doCheck(res, res => {
                        this.showSuccess(res.respMsg);
                        this.getList();
                        this.enableList = [];
                    });
                }, '信息获取失败')

            },
        }
    }
</script>

<style scoped>
    .item-box {
        margin-bottom: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/MemberChannelRank.vue